/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paginatedInvitationsDataSchema = z.object({
	data: z.array(
		z.object({
			invitationId: z.string(),
			email: z.string(),
			invitedByName: z.string().nullable(),
			invitedById: z.string().nullable(),
			status: z.union([z.literal('pending'), z.literal('accepted'), z.literal('revoked'), z.literal('expired')]),
			expirationDate: z.string().nullable(),
			role: z.union([z.literal('member'), z.literal('admin'), z.literal('jobillan'), z.literal('recruiter')]),
			createdAt: z.string().nullable(),
		}),
	),
	meta: z.object({ total: z.number(), limit: z.number(), offset: z.number() }),
})

export type PaginatedInvitationsDataSchema = z.infer<typeof paginatedInvitationsDataSchema>
